enum CollapserPositionVariant {
  NoTitleBar = 'no-title-bar',
  WithTitleBar = 'with-title-bar',
  WithTitleBarLarge = 'with-title-bar-large',
  WithTitleBarAndTaskBar = 'with-title-bar-and-task-bar',
  WithTitleBarAndTaskBarLarge = 'with-title-bar-and-task-bar-large',
  WithTitleBarAndTaskBarAndPendingTray = 'with-title-bar-and-task-bar-and-pending-tray',
}
export default CollapserPositionVariant;
